var React = require('react');

function Active (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"stroke":"#333333"},React.createElement("g",{"transform":"translate(3.000000, 3.000000)"},[React.createElement("circle",{"fill":"#FFFFFF","cx":"9","cy":"9","r":"9","key":0}),React.createElement("polyline",{"points":"13.2866522 5.9419983 7.19152908 12.3094575 4.55962161 9.80996853","key":1})]))));
}

Active.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = Active;

Active.default = Active;
